import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./../components/authProvider";


const RequireAuthAdmin = ({ children }) => {
    const { authUser, authLoading } = useAuth();
    if (authLoading === false && authUser?.isSuperAdmin === true) {
        return children;
    }
    else {
        return <Navigate to="/app/profile" replace />;
    }
};

export default RequireAuthAdmin